import React, { useState } from 'react'
import { BASE_URL } from '../env'

export default function AddCityCsv({ getAxiosInstance, Toast, getCities }) {
    const [IsShowing, setIsShowing] = useState(false)
    const [TotalItems, setTotalItems] = useState(0)
    const [SelectedFile, setSelectedFile] = useState(false)
    const [Rows, setRows] = useState([])
    const [States, setStates] = useState([])
    const [isLoading, setIsLoading] = useState(false);

    const addCity = () => {
        if(Rows.length === 0) return Toast.fire({ icon: 'error', title: 'No cities found to upload.' })
        if(States.length === 0) return Toast.fire({ icon: 'error', title: 'No state code found.' })

        setIsLoading(true);
        let params = { cities: JSON.stringify(Rows), states: JSON.stringify(States)}

        const data = Object.keys(params)
            .map((key) => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

        getAxiosInstance()
            .post("/admin/add-city-csv", data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
            .then((res) => {
                // Validating form
                setIsLoading(false);
                if(res.data.status === 'success'){
                    // console.log(res.data)
                    Toast.fire({ icon: 'success', title: `May take some time to upload.` })
                    handleClose()
                    // getCities()
                } else if (res.data.status === "error") Toast.fire({ icon: 'error', title: res.data.message })
                else Toast.fire({ icon: 'error', title: 'Cannot Process Request' })
            })
            .catch((err) => {
                setIsLoading(false);
                if(err.response.status === 401) Toast.fire({ icon: 'error', title: 'Unauthorized Access' })
                console.log(err);
            });
    }

    function handleClose() {
        setIsShowing(false)
        setTotalItems(0)
        setRows([])
        // window.location.reload()
    }

    return (
        <>
            <button type="button" class="btn btn-success btn-sm ml-1" onClick={() => setIsShowing(true)}>
                <i className="fas fa-file-upload"></i> Import CSV
            </button>
            {IsShowing && <div className={`modal fade show`} id="modal-default" style={{ display: 'block', paddingRight: 17 }} aria-modal="true" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Import City List <a href={`${BASE_URL}/sample/city_format.csv`} title="Sample CSV Format" className="ml-2"><i className="fas fa-question fa-xs"/></a></h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => handleClose()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <div className="form-group row">
                                <div className="col-12 custom-file">
                                    <input type="file" className="custom-file-input" width="100%" onChange={(e) => {
                                        // console.log("SELECTED FILE : ", e.target.files)
                                        if(e.target.files.length > 0) {
                                            if(e.target.files[0].type !== "text/csv") return Toast.fire({ icon: 'error', title: 'Please select .csv file.' })
                                            var reader = new FileReader();
                                            reader.readAsText(e.target.files[0]);
                                            reader.onload = function(event) {
                                                var csv = event.target.result;
                                                // console.log(`${csv}`);
                                                var rows = csv.split('\n');
                                                if(rows.length > 1000) return Toast.fire({ icon: 'error', title: 'Data cannot be more than 1000 rows.' })
                                                let headerElements = rows[0].replace('\\r',"").split(',');
                                                if(headerElements[0] !== "state_code" || headerElements[1].trim() !== "city") return Toast.fire({ icon: 'error', title: 'Invalid CSV format.' })
                                                // console.log("ROWS ", rows)
                                                let rowsArr = []
                                                let stateArr = []
                                                for (let i = 1; i < rows.length; i++) {
                                                    let elements = rows[i].split(',');
                                                    if(elements.length === 0) continue; 
                                                    if(elements[0] == "" || elements[1] == "") continue;

                                                    let cityData = {
                                                        state: elements[0],
                                                        name: elements[1].trim()
                                                    }
                                                    // console.log(elements);
                                                    rowsArr.push(cityData)
                                                    stateArr.push(cityData.state)
                                                }
                                                // console.log(rowsArr)
                                                setStates(stateArr)
                                                setRows(rowsArr)
                                                setSelectedFile(e.target.files[0])
                                                setTotalItems(rows.length > 0 ? (rows.length - 1) : 0)
                                            }
                                        } else {
                                            setRows([])
                                            setStates([])
                                            setSelectedFile(false)
                                        }
                                    }} />
                                    <label className="custom-file-label" htmlFor="exampleInputFile">{SelectedFile?SelectedFile.name:"Choose CSV City File"}</label>
                                </div>
                            </div>
                            {/* {TotalItems > 0 && <div className="row">
                                <div className="info-box bg-success">
                                    <span className="info-box-icon"><i className="fas fa-check-circle" /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">Valid Cities</span>
                                        <span className="info-box-number">{Rows.length}</span>
                                        <div className="progress">
                                            <div className="progress-bar" style={{width: `${(Rows.length/TotalItems) * 100}%`}} />
                                        </div>
                                        <span className="progress-description">
                                            {Rows.length} out of {TotalItems} valid cities found.
                                        </span>
                                    </div>
                                </div>
                            </div>} */}
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" className="btn btn-default" data-dismiss="modal" onClick={(e) => handleClose()}>Close</button>
                            <button type="button" className="btn btn-primary" onClick={(e) => addCity()} disabled={isLoading}>Add CSV City</button>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}
